var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 15.333,
    fill: "#FFD5B5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.227 13.727c5.034 0 9.408 2.944 11.578 5.742 1.027 1.325 1.559 2.644 1.559 3.64 0 .997-.532 2.316-1.56 3.641-2.169 2.799-6.543 5.743-11.577 5.743S12.82 29.549 10.65 26.75c-1.028-1.325-1.56-2.643-1.56-3.64 0-.997.532-2.316 1.56-3.641 2.17-2.799 6.543-5.742 11.577-5.742zm0 4.222a5.163 5.163 0 0 0-5.16 5.16c0 2.85 2.312 5.161 5.16 5.161a5.163 5.163 0 0 0 5.161-5.16c0-2.85-2.313-5.161-5.16-5.161zm0 1.876a3.286 3.286 0 0 1 3.284 3.285 3.285 3.285 0 1 1-3.284-3.284z",
    fill: "#FE5C04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeEye);
export default __webpack_public_path__ + "static/media/homeEye.e4cb4e54e8920c68eb3a9d236a65e0a9.svg";
export { ForwardRef as ReactComponent };